/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateDeliveryStatusDto
 */
export interface UpdateDeliveryStatusDto {
    /**
     * New delivery status
     * @type {string}
     * @memberof UpdateDeliveryStatusDto
     */
    'status': UpdateDeliveryStatusDtoStatusEnum;
}

export const UpdateDeliveryStatusDtoStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;

export type UpdateDeliveryStatusDtoStatusEnum = typeof UpdateDeliveryStatusDtoStatusEnum[keyof typeof UpdateDeliveryStatusDtoStatusEnum];


